import Request from '../modules/request.js'

const setDataContent = (code, data) => {
  console.log(`O CODIGO DE RESPOSTA É: ${code}`);

  if (code == 200) {
    document.getElementById('data-content').innerHTML = data;

  }
  if (code == 401) {
    console.log(code);

  }
}

export default class Prgm {

  #exec_delete;
  constructor() {
    this.#exec_delete = false;
    this.last_program_marked = null;
  }

  set exec_del(val) {
    this.#exec_delete = val;
  }

  get exec_del() {
    return this.#exec_delete;
  }

  getProgram(id) {
    const request = new Request();
    request.get(`/dashboard/programs/${id}/view`, (request, response) => {
      setDataContent(response.statusCode, response.data)
    });
  }

  getManagerProgram(id) {
    const request = new Request();
    request.get(`/dashboard/programs/${id}/manager`, (request, response) => {
      setDataContent(response.statusCode, response.data)
    });
  }

  prgNew() {
    const request = new Request();
    request.get("/dashboard/programs/new", (request, response) => {
      setDataContent(response.statusCode, response.data)
    });
  }

  getPrms() {
    Dashboard.setCurrentPage('programs');
    const request = new Request();
    request.get("/dashboard/programs", (request, response) => {
      setDataContent(response.statusCode, response.data)
    });
  }

  access(token, id, name) {
    window.open(`/${name}`, '_blank', 'width=600', 'height=400');
    //window.open(`/systems/${token}/${id}`, '_blank', 'width=600', 'height=400');
  }

  submitProgram(type = 0) {
    let auth_token = document.getElementsByName('authenticity_token')[0].value;
    let name = document.getElementById('program_name').value;
    let params = `authenticity_token=${auth_token}&program[name]=${name}`;
    let url = '/dashboard/programs/create';

    if (type == 1) {
      url = '/dashboard/programs/update';
      let prg_id = document.getElementById('program_id').value;
      params = `${params}&program[id]=${prg_id}`;
    }

    const request = new Request();
    request.post(url, params, (request, response) => {
      this.getPrms();
      Notify.delivery(response.data);

    });
  }

  rmv(id) {
    // TEM CERTEZA?
    if (this.exec_del) {
      const request = new Request();
      request.get(`/dashboard/programs/${id}/delete`, (request, response) => {
        this.getPrms();
        Notify.delivery(response.data);
      });
    }
    this.exec_del = false;
  }

  yousure(id) {
    let yousure = document.getElementById('you-sure');
    yousure.classList.add('grid');

    let msgTag = document.getElementById('you-sure-msg');
    msgTag.innerHTML = `Apagar Registro ${id}, prosseguir?`;

    let btncancel = document.getElementById('btn-cancel');
    btncancel.onclick = function() {
      window.Prgm.exec_del = false;
      yousure.classList.remove('grid');
    }
    let btnConfirm = document.getElementById('btn-confirm');
    btnConfirm.onclick = function() {
      window.Prgm.exec_del = true;
      yousure.classList.remove('grid');
      window.Prgm.rmv(id);
    }
  }

  select(program_id) {
    let program_field = document.getElementById('authorization_program_id');
    program_field.value = program_id;

    if (this.last_program_marked != null) {
      this.last_program_marked.classList.remove('marked');
      this.last_program_marked.lastElementChild.firstElementChild.classList.remove('green');
      this.last_program_marked.lastElementChild.firstElementChild.classList.add('dark');
    }

    let userSelect = document.getElementById(`p-${program_id}`);
    userSelect.classList.add('marked');
    userSelect.lastElementChild.firstElementChild.classList.remove('dark');
    userSelect.lastElementChild.firstElementChild.classList.add('green');
    this.last_program_marked = userSelect;
  }
}
